import moment from "moment";
import PropTypes from 'prop-types';
import { Col, Row } from "reactstrap";
import { useEffect, useState } from "react";
import { toast } from "../../../../../core/helpers/message-helper";
import InputController from "../../../../../core/ui/components/InputController";
import SelectController from "../../../../../core/ui/components/SelectController";
import { mapToSelect } from "../../../../../core/helpers/form-helper";
import { obtenerVersionesPorTipoContrato } from "../../../../Contratos/services/versiones-contratos-service";

const REQUIRED_RULE = {
    required: "Este campo es requerido",
};

const ContratosTab = ({
    errors,
    control,
    selects,
    clearField,
    getFieldValue,
    setFieldValue,
}) => {
    const [durationType, setDurationType] = useState(null);
    const [versionesContratos, setVersionesContratos] = useState([]);
    const [showContractFields, setShowContractFields] = useState({
        duration: true,
        serviceContract: false,
        fullSalary: false,
    });

    const tiposDuracionContrato = [
        {
            label: "Días",
            value: 1,
        },
        {
            label: "Meses",
            value: 2,
        },
    ];

    const onChangeDurationType = ({ value }) => {
        setDurationType(value);
    };

    useEffect(() => {
        calculateContractDuration();
    }, [durationType]);

    const calculateContractDuration = (
        duration = null,
        startContractDate = null
    ) => {
        startContractDate ??= getFieldValue("inicio_contrato");
        if (!startContractDate) return;

        duration ??= getFieldValue("duracion_contrato");
        if (!duration) return;

        const endContractDate = moment(startContractDate, "YYYY-MM-DD")
            .add(duration, durationType == 1 ? "days" : "months")
            .format("YYYY-MM-DD");

        setFieldValue("fin_contrato", endContractDate);
    };

    const clearServiceContractFields = () => {
        clearField("tiempo_pago");
        clearField("profesion_id");
        clearField("valor_poliza");
        clearField("valor_forma_pago");
        clearField("parametro_servicio_contrato_id");
    };

    const clearContractDurationFields = () => {
        clearField("fin_contrato");
        clearField("duracion_contrato");
        clearField("tipo_duracion_contrato");
    };

    const onChangeContractType = async (newContractType) => {
        const resp = await obtenerVersionesPorTipoContrato(
            newContractType.value
        );

        if (!resp.status) {
            toast.error(resp.message);
        } else {
            clearField("version_contrato_id");
            setVersionesContratos(
                resp.data.map((vc) => mapToSelect(vc.id, vc.nombre))
            );
        }

        if ("TI" == newContractType.abreviacion) {
            clearContractDurationFields();
            clearServiceContractFields();
            clearField("valor_prestacional");

            setShowContractFields({
                duration: false,
                serviceContract: false,
                fullSalary: false,
            });
        } else if ("PS" == newContractType.abreviacion) {
            clearField("valor_prestacional");
            setShowContractFields({
                duration: true,
                serviceContract: true,
                fullSalary: false,
            });
        } else if ("SI" == newContractType.abreviacion) {
            clearServiceContractFields();
            setShowContractFields({
                duration: true,
                serviceContract: false,
                fullSalary: true,
            });
        } else if ("SII" == newContractType.abreviacion) {
            clearServiceContractFields();
            clearContractDurationFields();
            setShowContractFields({
                duration: false,
                serviceContract: false,
                fullSalary: true,
            });
        } else {
            clearField("valor_prestacional");
            clearServiceContractFields();
            setShowContractFields({
                duration: true,
                serviceContract: false,
                fullSalary: false,
            });
        }
    };

    return (
        <Row>
            <Col sm={6}>
                <SelectController
                    errors={errors}
                    control={control}
                    rules={REQUIRED_RULE}
                    label="Tipo de contrato"
                    placeholder="Tipo de contrato"
                    onChange={onChangeContractType}
                    options={selects.contractTypes}
                    name="parametro_tipo_contrato_id"
                />
            </Col>
            <Col sm={6}>
                <SelectController
                    errors={errors}
                    control={control}
                    rules={REQUIRED_RULE}
                    name="version_contrato_id"
                    options={versionesContratos}
                    label="Versión del contrato"
                    placeholder="Versión del contrato"
                />
            </Col>
            {showContractFields.duration && (
                <>
                    <Col sm={6}>
                        <InputController
                            type="number"
                            errors={errors}
                            control={control}
                            rules={REQUIRED_RULE}
                            name="duracion_contrato"
                            label="Duración del contrato"
                            placeholder="Duración del contrato"
                            onInput={(e) =>
                                calculateContractDuration(e.target.value)
                            }
                        />
                    </Col>
                    <Col sm={6}>
                        <SelectController
                            errors={errors}
                            control={control}
                            rules={REQUIRED_RULE}
                            name="tipo_duracion_contrato"
                            label="Tipo Duración Contrato"
                            onChange={onChangeDurationType}
                            options={tiposDuracionContrato}
                        />
                    </Col>
                </>
            )}

            <Col sm={6}>
                <InputController
                    type="date"
                    errors={errors}
                    control={control}
                    rules={REQUIRED_RULE}
                    name="inicio_contrato"
                    label="Inicio del contrato"
                    placeholder="Inicio del contrato"
                    onInput={(e) =>
                        calculateContractDuration(null, e.target.value)
                    }
                />
            </Col>
            {showContractFields.duration && (
                <Col sm={6}>
                    <InputController
                        type="date"
                        readOnly={true}
                        errors={errors}
                        control={control}
                        name="fin_contrato"
                        rules={REQUIRED_RULE}
                        label="Fin del contrato"
                        placeholder="Fin del contrato"
                    />
                </Col>
            )}
            <Col sm={6}>
                <InputController
                    type="number"
                    name="salario"
                    label="Salario"
                    errors={errors}
                    control={control}
                    rules={REQUIRED_RULE}
                    placeholder="Salario"
                />
            </Col>
            <Col sm={6}>
                <InputController
                    type="number"
                    errors={errors}
                    control={control}
                    name="bonificacion"
                    label="Bonificación"
                    rules={REQUIRED_RULE}
                    placeholder="Bonificación"
                />
            </Col>
            {showContractFields.serviceContract && (
                <>
                    <Col sm={6}>
                        <InputController
                            errors={errors}
                            control={control}
                            rules={REQUIRED_RULE}
                            name="valor_forma_pago"
                            label="Valor y Forma de Pago"
                            placeholder="Valor y Forma de Pago"
                        />
                    </Col>
                    <Col sm={6}>
                        <SelectController
                            errors={errors}
                            control={control}
                            label="Profesión"
                            name="profesion_id"
                            rules={REQUIRED_RULE}
                            placeholder="Profesión"
                            options={selects.professions}
                        />
                    </Col>
                    <Col sm={6}>
                        <SelectController
                            errors={errors}
                            label="Servicio"
                            control={control}
                            rules={REQUIRED_RULE}
                            placeholder="Servicio"
                            options={selects.services}
                            name="parametro_servicio_contrato_id"
                        />
                    </Col>
                    <Col sm={6}>
                        <InputController
                            type="number"
                            errors={errors}
                            control={control}
                            name="tiempo_pago"
                            rules={REQUIRED_RULE}
                            label="Tiempo de Pago (Días)"
                            placeholder="Tiempo de Pago"
                        />
                    </Col>
                    <Col sm={6}>
                        <InputController
                            type="number"
                            label="Poliza"
                            errors={errors}
                            control={control}
                            name="valor_poliza"
                            placeholder="Poliza"
                            rules={REQUIRED_RULE}
                        />
                    </Col>
                </>
            )}
            {showContractFields.fullSalary && (
                <Col sm={6}>
                    <InputController
                        type="number"
                        errors={errors}
                        control={control}
                        rules={REQUIRED_RULE}
                        name="valor_prestacional"
                        label="Factor Prestacional"
                        placeholder="Factor Prestacional"
                    />
                </Col>
            )}
        </Row>
    );
};

ContratosTab.propTypes = {
    errors: PropTypes.object,
    control: PropTypes.object,
    selects: PropTypes.object,
    clearField: PropTypes.func,
    getFieldValue: PropTypes.func,
    setFieldValue: PropTypes.func,
};

export default ContratosTab;